import { Button, Alert } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import { Link } from 'react-router-dom';
import { formatIsoDate } from '@front-activerse/common-components';
import { PATH_DAY_PLAN_INDEX } from '../../../MealPlanPaths';

const MeasurementAlert = ({ date, isTimeToNagForCurrentMeasurement }) => {
  const { t } = useTranslator();

  if (isTimeToNagForCurrentMeasurement) {
    return (
      <Alert color="info" fade={false}>
        <p className="small mb-l">{t('addMesurement.notification.content')}</p>
        <div className="text-center">
          <Button
            color="primary"
            size="sm"
            tag={Link}
            to="/measurements/add"
            state={{
              from: {
                pathname: `${PATH_DAY_PLAN_INDEX}/${formatIsoDate(date)}`,
              },
            }}
            // onClick={() =>
            //   this.props.trackFirebaseEvent('user_action', {
            //     action: 'tap-add_weight',
            //     location: 'Dietplan',
            //   })
            // }
          >
            {t('addMesurement.notification.button')}
          </Button>
        </div>
      </Alert>
    );
  }

  return '';
};

export default MeasurementAlert;
